import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 1rem 1rem 2rem;
  gap: 1rem;
  &:not(:last-child) {
    border-bottom: 4px solid #e4e4e4;
  }
  @media (max-width: 852px) {
    align-items: ${({ $offersLength }) => ($offersLength > 1 ? 'flex-start' : 'unset')};
  }
`;

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 852px) {
    flex-wrap: unset;
  }
`;

export const Title = styled.span`
  font-size: 1.5em;
  font-weight: 700;
  color: #47484b;
`;
